(function () {
    "use strict";

    const mapEnumValuesToCodes = (codes) => (enumValues) => {
        return codes.filter(code => enumValues.includes(code.Key) || enumValues.includes(Number.parseInt(code.Key, 10)));
    };

    angular.module("app").factory("screeningService", ScreeningServiceFactory);

    ScreeningServiceFactory.$inject = ["$rootScope", "$http", "settingsService", "apiClientFactory", "enumService", "webApiServices",];
    function ScreeningServiceFactory($rootScope, $http, settingsService, apiClientFactory, enumService, webApiServices) {
        return {
            OpenedScreening: undefined,
            // PersonScreeningController, OrganisationScreeningController, ScreeningIvmController, ScreeningFvmController
            setAsAccepted: setAsAccepted,
            // OrganisationScreeningController, SetScreeningAnswer, ScreeningIvmController, ScreeningFvmController
            saveScreening: apiClientFactory.post("api/Screening/SaveScreening"),
            // ScreeningIvmController
            getPhaseFilesSetAccepted: getPhaseFilesSetAccepted,
            Sign: sign,
            signInstallations,
            ConfirmCisResults: confirmCisResults,
            getPossibleScreeningResults: getPossibleScreeningResults,
            getScreeningAttachments: getScreeningAttachments,
            createScreening: apiClientFactory.post("api/Screening/CreateScreening"),
        };

        function getPhaseFilesSetAccepted(screeningType, screeningIds, successCallback, errorCallback, finallyCallback) {
            const data = { ScreeningType: screeningType, ScreeningIds: screeningIds };
            const httprequest = $http({
                method: "post",
                url: settingsService.applicationPath + "api/Screening/GetPhaseFilesSetAccepted",
                data: data,
                responseType: "arraybuffer"
            });
            httprequest.then(
                function (result, _status, _headers, config) {
                    successCallback(result.data, result.status, result.headers(), config);
                },
                function (result, status, headers, config) {
                    errorCallback(result.data, status, headers, config);
                }).finally(finallyCallback);
        }

        function setAsAccepted(screening, successCallback, errorCallback, finallyCallback) {
            const httprequest = $http({
                method: "post",
                traditional: true,
                url: settingsService.applicationPath + "api/Screening/SetAsAccepted/?screeningId=" + screening
            });
            httprequest.then(successCallback, errorCallback).finally(finallyCallback);
        }

        function sign(payload) {
            return $http({
                method: "post",
                traditional: true,
                url: settingsService.applicationPath + "Screenings/SignScreenings",
                data: payload
            });
        }

        function signInstallations(payload) {
            return $http({
                method: "post",
                traditional: true,
                url: settingsService.applicationPath + "Screenings/SignInstallations",
                data: payload
            });
        }

        function confirmCisResults(payload) {
            return $http({
                method: "post",
                traditional: true,
                url: settingsService.applicationPath + "Screenings/ConfirmCisScreeningResults",
                data: payload
            });
        }

        function getPossibleScreeningResults(screening) {
            const resultCodes = enumService.ScreeningResultCode;
            const mapToResultCodes = mapEnumValuesToCodes($rootScope.codeScreeningResultsCOL);

            const allowedScreeningResultTypesByService = {
                "FOD_ECO": mapToResultCodes([resultCodes.RAS, resultCodes.RASrevision, resultCodes.Report]),
                "VSSE": mapToResultCodes([resultCodes.RAS, resultCodes.RASabroad, resultCodes.SecurityCheck, resultCodes.AdministrativeRefusal, resultCodes.AlternativeMeasure, resultCodes.Report, resultCodes.ReportedClassified]),
                "ADIV-SGRS": mapToResultCodes([resultCodes.RAS, resultCodes.RASabroad, resultCodes.SecurityCheck, resultCodes.AdministrativeRefusal, resultCodes.AlternativeMeasure, resultCodes.Report, resultCodes.ReportedClassified]),
            };

            let possibleScreeningResults = [...(allowedScreeningResultTypesByService[screening.DoneBy] ?? Object.values(resultCodes))];

            if (screening.TypeCode == enumService.ScreeningTypeCode.SecurityCheck /* 40 */) {
                const allowedSecurityCheckResultCodes = [resultCodes.SecurityCheck /* 12 */, resultCodes.Report /* 30 */, resultCodes.ReportedClassified /* 31 */];
                possibleScreeningResults = possibleScreeningResults.filter((c) => allowedSecurityCheckResultCodes.includes(Number.parseInt(c.Key, 10)));
            }
            else if (screening.TypeCode == enumService.ScreeningTypeCode.FVM /* 10 */) {
                const allowedOrganisationScreeningResultCodes = [resultCodes.RAS /* 10 */, resultCodes.RASrevision /* 13 */, resultCodes.Report /* 30 */];
                possibleScreeningResults = possibleScreeningResults.filter((c) => allowedOrganisationScreeningResultCodes.includes(Number.parseInt(c.Key, 10)));
            }
            else if (screening.IsForeign) {
                possibleScreeningResults = possibleScreeningResults.filter((c) => Number.parseInt(c.Key, 10) > 0 && Number.parseInt(c.Key, 10) !== resultCodes.ReportedClassified);
            }
            else {
                const forbiddenCodes = [resultCodes.SecurityCheck /* 12 */, resultCodes.ReportedClassified /* 31 */];
                possibleScreeningResults = possibleScreeningResults.filter((c) => Number.parseInt(c.Key, 10) > 0 && !forbiddenCodes.includes(Number.parseInt(c.Key, 10)));
            }

            // A reinvestigation should only result in RAS or Report
            if (screening.TypeCode == enumService.ScreeningTypeCode.PersonReinvestigation) {
                possibleScreeningResults = possibleScreeningResults.filter((c) => [resultCodes.RAS /* 10 */, resultCodes.Report /* 30 */].includes(Number.parseInt(c.Key, 10)));
            }

            return possibleScreeningResults;
        }

        function getScreeningAttachments(screeningPublicId) {
            return new Promise((resolve, reject) => {
                webApiServices.GetScreeningAttachments({ ScreeningPublicId: screeningPublicId }, (result => resolve(result.data)), () => reject());
            });
        }
    }
})();
